/**
 * Shared constants for sourcing request lists
 */

/**
 * Default click action for sourcing request lists
 */
export const SOURCING_REQUEST_CLICK_ACTION = {
	type: 'navigate' as const,
	path: '/sourcing-requests/{id}',
};

/**
 * Default actions for sourcing request lists
 */
export const SOURCING_REQUEST_ACTIONS = [
	{
		id: 'create-sourcing-request',
		label: 'New Request',
		icon: 'plus',
		type: 'create' as const,
		position: 'header' as const,
	},
];
